import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';


export default {
  mixins: [
    cmsContentMixin,
  ],
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.RESEARCH)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/research/research.js